import { useState  } from 'react';
import { decodeId, handleError, handleSuccess } from 'utils';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { addFiscalYear, useGetFiscalYear } from 'repositories/office-repository';


const useFiscalYearModule = ( t ) => {
    const [startMonth, setStartMonth] = useState(1);
    const [endMonth, setEndMonth] = useState(12);
    const [error, setError] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    let { officeId } = useParams();
    officeId = +decodeId(officeId);
    const { isLoading, data, refetch } = useGetFiscalYear(officeId);


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const params = {
                officeId: officeId,
                startMonth: startMonth,
                endMonth: endMonth
            };
            if(params?.startMonth && params?.endMonth) {
                setShowLoader(true)
                let res = await addFiscalYear(params);
                setError("");
                if (res.status) {
                    handleSuccess(res.message);
                    refetch();
                    setShowLoader(false)
                }
            } else {
                setError(t("dashBoard.pleaseSelectFiscalYear"));
            }
        } catch (err) {
            handleError(err.message);
            setShowLoader(false);
        }

    }

    const isAnyLoading = isLoading || showLoader;
    return {
        data: {
            isAnyLoading,
            data,
            error
        },
        methods: {
            setStartMonth,
            setEndMonth,
            handleSubmit
        }
    };
};

export default useFiscalYearModule;